import CryptoJS from "crypto-js";

const CRASH_FILTER_QUERY_PAYLOAD_EXPIRY_TIME = 1000 * 60 * 60 * 24;
const CRASH_FILTER_QUERY_PAYLOAD_KEY = "SID-CRASH-FILTER-QUERY-PAYLOAD-REF";

function storageKey(referenceId) {
  return `${CRASH_FILTER_QUERY_PAYLOAD_KEY} - ${referenceId}`;
}

/** Stable id so the same filters + device reuse one localStorage entry (overwrite, not duplicate). */
function referenceIdFromPayload(payLoad) {
  const normalized = {
    from: Number(payLoad?.from),
    to: Number(payLoad?.to),
    query: payLoad?.query == null ? "" : String(payLoad.query),
    sid: payLoad?.sid == null ? "" : String(payLoad.sid),
    cdsn: payLoad?.cdsn == null ? "" : String(payLoad.cdsn),
  };
  return CryptoJS.SHA256(JSON.stringify(normalized))
    .toString(CryptoJS.enc.Hex)
    .slice(0, 32);
}

function stashCrashFilterQueryPayLoad(payLoad) {
  const referenceId = referenceIdFromPayload(payLoad);

  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify({
      payload: payLoad,
      expiresAt: Date.now() + CRASH_FILTER_QUERY_PAYLOAD_EXPIRY_TIME,
    }),
    referenceId
  ).toString();

  localStorage.setItem(storageKey(referenceId), encryptedPayload);

  return referenceId;
}

function peekCrashFilterQueryPayLoad(referenceId) {
  if (referenceId == null || referenceId === "") return null;

  const encryptedPayload = localStorage.getItem(storageKey(referenceId));

  if (!encryptedPayload) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedPayload, referenceId);

    const decryptedPayload = bytes.toString(CryptoJS.enc.Utf8);

    const { payload, expiresAt } = JSON.parse(decryptedPayload);

    if (expiresAt < Date.now()) {
      localStorage.removeItem(storageKey(referenceId));
      return null;
    }

    return payload;
  } catch (error) {
    console.error("Failed to decrypt payload", error);
    return null;
  }
}

function clearCrashFilterQueryPayLoads() {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(`${CRASH_FILTER_QUERY_PAYLOAD_KEY} - `)) {
      localStorage.removeItem(key);
    }
  });
}

export {
  stashCrashFilterQueryPayLoad,
  peekCrashFilterQueryPayLoad,
  clearCrashFilterQueryPayLoads,
  CRASH_FILTER_QUERY_PAYLOAD_EXPIRY_TIME,
};
